var map = {
	"./1.jpg": "8554",
	"./2.jpg": "405a",
	"./4.jpg": "bafb",
	"./5.jpg": "4d0f",
	"./awning.jpeg": "ca30",
	"./awning3.png": "5129",
	"./banner1.jpg": "ba57",
	"./beach11.png": "02f9",
	"./coffeeset.jpg": "f104",
	"./curtain.png": "8980",
	"./dd_vertical_logo.png": "fa3c",
	"./dining.jpg": "74185",
	"./gazebo1.png": "bf20",
	"./grass.png": "c4f3",
	"./living-or-sofa-sets.jpg": "2a91",
	"./logo.png": "cf05",
	"./swings.png": "beef",
	"./umbrella1.png": "10fd",
	"./wood.png": "b196"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";